module.exports = __webpack_public_path__ + "static/media/28.628eff03.mp3";